import React from 'react';
import {
    FooterContainer,
    FooterWrapper,
    FooterHeader,
} from './FooterElements';

const Footer = () => {
    return (
        <FooterContainer>
            <FooterWrapper>
                <FooterHeader>
                    Renee Hammons @2021
                </FooterHeader>
            </FooterWrapper>
        </FooterContainer> 
    )
}

export default Footer
